import { AfterViewInit, Component, OnInit, ViewChild, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { TeamService } from "../core/services/team.service";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import { MatIconButton } from "@angular/material/button";
import { MatTabsModule } from '@angular/material/tabs';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggle, MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from "@angular/material/icon";
import { NgIf } from "@angular/common";
import { ActivatedRoute, RouterLink } from "@angular/router";
import { environment } from '../../environments/environment';
import { EventService } from '../core/services/event.service';

@Component({
    selector: 'app-home',
    standalone: true,
    imports: [MatTableModule, MatPaginatorModule, MatIconModule, MatTabsModule, MatIconButton, MatInputModule, MatSlideToggle, MatFormFieldModule, MatIcon, NgIf, RouterLink],
    templateUrl: './home.component.html',
    styleUrl: './home.component.css',
    animations: [
        trigger('detailExpand', [
            state('collapsed,void', style({ height: '0px', minHeight: '0', backgroundColor: '*' })),
            state('expanded', style({ height: '*', backgroundColor: 'whitesmoke' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
})
export class HomeComponent implements OnInit, AfterViewInit {
    apiUrl = environment.apiUrl
    teams = [];
    eventMap = new Map<string, string>();
    columnsToDisplay = ["rank", "name", "total", "e1", "e2", "status"];
    columnsToDisplayWithExpand = [...this.columnsToDisplay, 'expand'];
    dataSource = new MatTableDataSource<any>([]);
    teamPage = 0;
    teamIndex = 0;
    teamID = 0;
    prevPageSize = 25;
    hideInvited = false;
    searchInput = "";
    expandedElement: any | null;
    season!: number;
    private userAgent: string = navigator.userAgent;
    avatarMap = new Map<number, string>();

    constructor(private route: ActivatedRoute,
        private teamService: TeamService,
        private eventService: EventService) { }

    isMobileBrowser(): boolean {
        let check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent);
        return check;
    }

    ngOnInit() {
        if (this.isMobileBrowser()) {
            this.columnsToDisplay = ["rank", "name", "total", "status"];
            this.columnsToDisplayWithExpand = [...this.columnsToDisplay];
        }
        else {
            this.columnsToDisplay = ["rank", "name", "total", "e1", "e2", "status"];
            this.columnsToDisplayWithExpand = [...this.columnsToDisplay, 'expand'];
        }

        this.route.paramMap.subscribe(params => {
            const season = params.get('season');

            if (season) {
                // in case the season is provided in the URL
                this.season = Number(season);
                this.getTeamAndEventData();
            } else {
                // in case no url is provided
                this.eventService.getCurrentEventSeason().subscribe(apiResponse => {
                   this.season = apiResponse.currentSeason;
                   this.getTeamAndEventData();
                });
                
                
            }
        });
    }

    getTeamAndEventData()
    {
        this.teamService.getAllAvatars(this.season).subscribe(avatars => {
            avatars.forEach(a => this.avatarMap.set(a.teamNumber, a.encodedAvatar));
        });

        this.dataSource.filterPredicate = this.createFilterPredicate();

        this.teamService.getTeams(this.season).subscribe(res => {
            this.dataSource.data = res.teams;
            this.teamID = parseInt(this.route.snapshot.paramMap.get('teamId') || "0");
            this.teamIndex = this.dataSource.data.findIndex(teams => teams.teamNumber === this.teamID);
            this.teamPage = (this.teamIndex < 0) ? 0 : Math.floor(this.teamIndex / this.prevPageSize);
            this.expandedElement = this.dataSource.data[this.teamIndex];
            this.paginator.pageIndex = (this.teamIndex < 0) ? 0 : Math.floor(this.teamIndex / this.prevPageSize);
            this.dataSource.paginator = this.paginator;
        });

        this.eventService.getAllEventsData(this.season).subscribe(res => {
            this.buildEventMap(res.Events);
        });
    }

    // @ts-ignore
    @ViewChildren('expanded', { read: ElementRef }) tableRows: QueryList<ElementRef<HTMLElement>>;
    // @ts-ignore
    @ViewChild(MatPaginator) paginator: MatPaginator;

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;

        this.paginator.page.subscribe((event) => {
            if (event.pageSize !== this.prevPageSize) {
                this.paginator.pageIndex = (this.teamIndex < 0) ? 0 : Math.floor(this.teamIndex / event.pageSize);
                this.dataSource.paginator = this.paginator;
                this.prevPageSize = event.pageSize;
            }
        });

        this.tableRows.changes.subscribe(res => {
            let scrollTo: ElementRef = res.find((team: ElementRef) => parseInt(team.nativeElement.innerHTML) === this.teamID);
            if (scrollTo != null) {
                setTimeout(() => {
                    scrollTo.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                });
            }
        });
    }

    getAvatar(teamNumber: number): string | null {
        return this.avatarMap.get(teamNumber) ?? null;
    }

    // Build the lookup map once
    buildEventMap(events: { code: string; name: string }[]) {
        this.eventMap = new Map(events.map(e => [e.code, e.name]));
    }

    getEventNameByCode(eventCode: string): string {
        return this.eventMap.get(eventCode) || '';
      }

    toggleQualified(event: MatSlideToggleChange) {
        this.hideInvited = event.checked;
        this.dataSource.filter = JSON.stringify(
            { input: this.searchInput, hideInvited: this.hideInvited }
        );
    }

    applyFilter(event: Event) {
        // applies filtering to all columns
        const filterValue = (event.target as HTMLInputElement).value;
        this.searchInput = filterValue.trim().toLowerCase();
        this.dataSource.filter = JSON.stringify(
            { input: this.searchInput, hideInvited: this.hideInvited }
        );
    }

    createFilterPredicate() {
        return (data: any, filter: string) => {
            const filterObject = JSON.parse(filter);
            return (filterObject.hideInvited ? data.championshipStatus === "None" : true)
                && (data.teamNumber.toString().includes(filterObject.input)
                || data.nameShort.toLowerCase().includes(filterObject.input)
                || (data.rank.toString().includes(filterObject.input))
                || (data.totalPoints !== null && data.totalPoints.toString().includes(filterObject.input))
                    || (data.regional1Points !== null && data.regional1Points.toString().includes(filterObject.input))
                    || (data.regional2Points !== null && data.regional2Points.toString().includes(filterObject.input))
                    || (data.regional2PointsProjection !== null && data.regional2PointsProjection.toString().includes(filterObject.input))
                    || (data.qualifiedFirstCmpAwardName !== null && data.qualifiedFirstCmpAwardName.toLowerCase().includes(filterObject.input))
                    || (data.qualifiedFirstCmpAwardName !== null && data.qualifiedFirstCmpAwardName.toLowerCase().includes(filterObject.input))
                );
        }
    }
}
